/* eslint-disable react/display-name */

import i18n from "i18n";
import moment from "moment";
import { Tag } from "antd";

const Columns = {};

const renderDataValue = (value, renderStyle = {}) => {
  const style = value ? renderStyle : { ...renderStyle, color: "#c0c0c0" };
  return <span style={style}>{value || i18n.t("general.none")}</span>;
};
const renderStatusValue = (value) => {
  const insuranceDate = moment(value).format("DD/MM/YYYY");
  const status = moment(insuranceDate, "DD/MM/YYYY").isAfter();
  return (
    <span
      style={{ color: status === false ? "red" : "green", fontWeight: "bold" }}
    >
      {status === false
        ? i18n.t("products.expire")
        : i18n.t("products.noExpire")}
    </span>
  );
};
Columns.productId = {
  dataIndex: ["order", "orderIdCustom"],
  key: "orderIdCustom",
  title: "Mã đơn hàng",
  render: (_, record) => renderDataValue(record?.order?.orderIdCustom || record?.order?.orderId || "N/A"),
  width: 150,
};

Columns.customerName = {
  dataIndex: ["customer", "name"],
  key: "customerName",
  title: "Khách hàng",
  render: (_, record) => renderDataValue(record?.customer?.name),
  width: 200,
};

Columns.customerPhone = {
  dataIndex: ["customer", "phone"],
  key: "customerPhone",
  title: "Số điện thoại",
  render: (_, record) => renderDataValue(record?.customer?.phone),
  width: 150,
};

Columns.role = {
  dataIndex: ["customer", "createdBy"],
  key: "role",
  title: "Người tạo",
  render: (_, record) => {
    const createdBy = record?.customer?.createdBy;
    if (createdBy === "admin") {
      return <Tag color="gold">Admin</Tag>;
    } else if (createdBy === "user") {
      return <Tag color="blue">Khách hàng</Tag>;
    }
    return <Tag color="default">Không rõ</Tag>;
  },
  width: 100,
};

Columns.name = {
  title: i18n.t("products.name"),
  dataIndex: ["product", "name"],
  key: "productName",
  sorter: true,
  render: (_, record) => renderDataValue(record?.product?.name),
  width: 200,
};

Columns.imei = {
  dataIndex: "imei",
  key: "imei",
  title: "Imei (Series)",
  render: (imei) => renderDataValue(imei),
  width: 200,
};

Columns.saleDate = {
  dataIndex: "warrantyStartDate",
  key: "warrantyStartDate",
  title: i18n.t("products.saleDate"),
  width: 150,
  render: (warrantyStartDate) => renderDataValue(moment(warrantyStartDate).format("DD/MM/YYYY")),
};

Columns.insuranceDate = {
  title: i18n.t("products.insuranceDate"),
  dataIndex: "warrantyStartDate",
  key: "warrantyStartDate",
  sorter: true,
  render: (warrantyStartDate) =>
    renderDataValue(moment(warrantyStartDate).format("DD/MM/YYYY")),
  width: 200,
};

Columns.warrantyExpirationDate = {
  title: i18n.t("products.warrantyExpirationDate"),
  dataIndex: "warrantyExpirationDate",
  key: "warrantyExpirationDate",
  sorter: true,
  render: (warrantyExpirationDate) =>
    renderDataValue(moment(warrantyExpirationDate).format("DD/MM/YYYY")),
  width: 200,
};

Columns.status = {
  title: i18n.t("products.status"),
  dataIndex: "warrantyExpirationDate",
  key: "status",
  render: (warrantyExpirationDate) => renderStatusValue(warrantyExpirationDate),
  width: 150,
};

// Action column sẽ được định nghĩa riêng trong component sử dụng

export default Columns;
